// extracted by mini-css-extract-plugin
module.exports = {"container":"OurPartners_container__AUzSa","titleBlock":"OurPartners_titleBlock__51NCU","container_body":"OurPartners_container_body__JZmig","item":"OurPartners_item__GWE0A"};